import { useAuth0 } from "@auth0/auth0-react";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { ReactComponent as ChildIcon } from "assets/icons/triggericon/child.svg";
import { ReactComponent as EmailIcon } from "assets/icons/triggericon/email.svg";
import { ReactComponent as GrandChildIcon } from "assets/icons/triggericon/grandChild.svg";
import { ReactComponent as GrandParentIcon } from "assets/icons/triggericon/grandParent.svg";
import { ReactComponent as HomeIcon } from "assets/icons/triggericon/home.svg";
import { ReactComponent as HospitalIcon } from "assets/icons/triggericon/hospital.svg";
import { ReactComponent as OtherIcon } from "assets/icons/triggericon/other.svg";
import { ReactComponent as ParentIcon } from "assets/icons/triggericon/parent.svg";
import { ReactComponent as PhoneIcon } from "assets/icons/triggericon/phone.svg";
import { ReactComponent as SiblingIcon } from "assets/icons/triggericon/sibling.svg";
import { ReactComponent as SmsIcon } from "assets/icons/triggericon/sms.svg";
import { ReactComponent as SpouseIcon } from "assets/icons/triggericon/spouse.svg";
import { InputField } from "components";
import InfoTooltip from "components/InfoTooltip";
import { LabelField } from "components/LabelField";
import SwitchTabs from "components/SwitchTabs";
import { useFormik } from "formik";
import PastoralService from "Lib/API/PastoralApi";
import { taskAutomationSchema } from "pages/ValidationSchema/taskAutomationSchema";
import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import CreateTriggerHeader from "./CreateTriggerHeader";
import CreateTriggerTabs from "./CreateTriggerTabs";
import "./index.scss";
import { disableRecurringList, isPersonalOptions } from "./tabsContants";
import TextMessage from "./TextMessage";
import TriggerCommon from "./TriggerCommon";


const selectControlStyles = {
  backgroundColor: "#F3F6F9",
  borderColor: "#F3F6F9",
  color: "#3F4254",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const selectStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "200px",
  }),
};

const formatOptionLabel = ({ label, _id }) => {
  return (
    <div className="dropdown-container" key={_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};




function CreateTrigger({ closeModal, handleClose, eventsTypes, usersData, taskData, type, fetchTasks, getEventTypesLoading }) {
  const [isLoading, setIsLoading] = useState(false);

  const createTriggerHandler = async (payload) => {
    setIsLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.createTaskAutomation({ data: payload, token })
      .then((response) => {
        toastr.success("Success", "Task Automation created successfully");
        fetchTasks(1);
        handleClose();
      })
      .catch((error) => {
        console.log('error :', error);
        toastr.error("Error", error?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const updateTriggerHandler = async (payload) => {
    setIsLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.updateTaskAutomation({ data: payload, token, id: taskData?.id })
      .then((response) => {
        toastr.success("Success", "Task Automation Updated Successfully");
        fetchTasks(1);
        handleClose();
      })
      .catch((error) => {
        console.log('error :', error);
        toastr.error("Error", error?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
        handleClose();
      });
  }



  const { getAccessTokenSilently } = useAuth0();

  const checkValidation = () => {
    if (!formik.values?.eventType) {
      toastr.info("validation", "Please select a event type");
      return false;
    }
    if (!formik.values?.timeType) {
      toastr.info("validation", "Please select a time type");
      return false;
    }
    if (formik.values?.timeType !== "on the day" && (!formik.values?.timeUnit)) {
      toastr.info("validation", "Please enter a time unit");
      return false;
    }
    if (formik.values?.timeType !== "on the day" && (!formik.values?.timePeriod)) {
      toastr.info("validation", "Please select a time period");
      return false;
    }
    if (formik.values?.isRecurring && (!formik.values?.recurringType)) {
      toastr.info("validation", "Please select a recurring type");
      return false;
    }
    if (formik.values?.isLimit && (!formik.values?.age)) {
      toastr.info("validation", "Please enter an age");
      return false;
    }
    if (formik.values?.isLimit && (!formik.values?.limit)) {
      toastr.info("validation", "Please select a limit");
      return false;
    }
    if (!formik.values?.actionType) {
      toastr.info("validation", "Please select a action type");
      return false;
    }
    if (!formik.values?.clergyType) {
      toastr.info("validation", "Please select an assignee");
      return false;
    }
    // if (!formik.values?.subject) {
    //   toastr.info("validation", "Please enter a subject");
    //   return false;
    // }
    if (!formik.values?.text) {
      toastr.info("validation", "Please enter a message");
      return false;
    }
    if (formik.values?.isPersonal === 0 && !formik.values?.contactType) {
      toastr.info("validation", "Please select a contact type");
      return false;
    }


    return true;
  }

  const initialValues = {
    eventType: type === "edit" ? eventsTypes?.find((item) => item?.value === taskData?.eventType) || null : null,
    timeType: type === "edit" ? (taskData?.when === 0) ? "on the day" : (taskData?.after) ? "after" : "before" : "before",
    timeUnit: type === "edit" ? taskData?.when : 1,
    timePeriod: type === "edit" ? taskData?.unit : "Day",
    isRecurring: type === "edit" ? taskData?.recurring ? true : false : false,
    recurringType: type === "edit" ? taskData?.recurring : 1,
    isLimit: type === "edit" ? taskData?.condition ? true : false : false,
    limit: type === "edit" ? taskData?.condition : "=",
    age: type === "edit" ? taskData?.years : 18,
    actionType: type === "edit" ? taskData?.actiontypeId : 2,
    contactType: type === "edit" ? taskData?.relationshipTo : 12,
    isPersonal: type === "edit" ? taskData?.relationshipTo ? 0 : 1 : 1,
    subject: type === "edit" ? taskData?.subject : "",
    text: type === "edit" ? taskData?.text : "",
    active: type === "edit" ? taskData?.active1 ? true : false : true,
    clergyType: type === "edit" ? usersData?.find((item) => item?.value === taskData?.clergyTypeId) || null : null,
    dayID: type === "edit" ? taskData?.dayID : 9,
    dayInMonth: type === "edit" ? taskData?.dayInMonth : 1,
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: taskAutomationSchema,

    onSubmit: async (values) => {
      if (!checkValidation()) return;
      const input = {
        active1: values?.active,
        eventType: values?.eventType?.value,
        when: values?.timeType === "on the day" ? 0 : values?.timeUnit,
        unit: values?.timeType === "on the day" ? "Day" : values?.timePeriod,
        recurring: values?.isRecurring ? values?.recurringType : 0,
        after: values?.timeType === "after" ? true : false,
        actiontype: values?.actionType,
        subject: values?.subject,
        text: values?.text,
        relationshipTo: values?.isPersonal === 0 ? values?.contactType : null,
        clergyType: values?.clergyType?.value,
        condition: values?.isLimit ? values?.limit : null,
        years: values?.isLimit ? values?.age : null,
        dayID: values?.dayID,
        dayInMonth: values?.dayInMonth,
      };
      if (type === "edit") {
        updateTriggerHandler(input);
      } else
        createTriggerHandler(input);
    }
  });


  const actionTypes = [
    {
      label: "Email",
      value: 2,
      icon: <EmailIcon />,
      className: "fill-color",
    },
    {
      label: "Phone Call",
      value: 3,
      icon: <PhoneIcon />,
      className: "fill-color",
    },
    {
      label: "SMS",
      value: 1,
      icon: <SmsIcon />,
      className: "stroke-color",
    },
    {
      label: "Home Visit",
      value: 4,
      icon: <HomeIcon />,
      className: "fill-color",
    },
    {
      label: "Hospital Visit",
      value: 5,
      icon: <HospitalIcon />,
      className: "fill-color",
    },
    {
      label: "Others",
      value: 10,
      icon: <OtherIcon />,
      className: "fill-color",
    },
  ]

  const contactTypes = [
    {
      label: "Spouse",
      value: 12,
      icon: <SpouseIcon />,
      className: "fill-color",
    },
    {
      label: "Parent",
      value: 8,
      icon: <ParentIcon />,
      className: "fill-color",
    },
    {
      label: "Child",
      value: 11,
      icon: <ChildIcon />,
      className: "fill-color",
    },
    {
      label: "Grandchild",
      value: 10,
      icon: <GrandChildIcon />,
      className: "fill-color",
    },
    {
      label: "Grandparent",
      value: 9,
      icon: <GrandParentIcon />,
      className: "fill-color",
    },
    {
      label: "Sibling",
      value: 3,
      icon: <SiblingIcon />,
      className: "fill-color",
    },
  ]


  const onTokenDoubleClicked = (tag) => {
    formik.setFieldValue("text", formik.values.text + `${tag} `);
  };
  const onTextAreaChange = (event) => {
    formik.setFieldValue("text", event.target.value);
  };




  return (
    <div className="add-trigger-section">
      <CreateTriggerHeader closeModal={closeModal} formik={formik} onSubmit={formik.handleSubmit} isLoading={isLoading} />

      <div className="group-input">
        <LabelField
          title={"Event Type"}
          style={{
            fontSize: "12px",
          }}
          mandatory={true}
        />
        <Select
          menuPosition={'fixed'}
          classNamePrefix="react-select"
          formatOptionLabel={formatOptionLabel}
          placeholder="Select a event type"
          options={eventsTypes || []}
          isLoading={getEventTypesLoading}
          styles={selectStyles}
          onChange={(value) => {
            const disabledRecurring = disableRecurringList?.includes(value?.value);
            const disabledLimit = value?.value !== 35 && value?.value !== 36;
            formik.setFieldValue("eventType", value);
            if (disabledRecurring) {
              formik.setFieldValue("isRecurring", false);
            }
            if (disabledLimit) {
              formik.setFieldValue("isLimit", false);
            }
          }}
          value={formik.values?.eventType}
          components={{ DropdownIndicator }}
        />
      </div>

      <CreateTriggerTabs formik={formik} />
      {console.log("formik", formik)}
      <div className="d-flex flex-column" style={{ gap: "1rem" }}>
        <LabelField
          title={"Action Type"}
          style={{
            fontSize: "12px",
          }}
          mandatory={true}
        />
        <TriggerCommon
          options={actionTypes}
          onChange={(value) => {
            formik.setFieldValue("actionType", value);
          }}
          selectedValue={formik.values?.actionType}
        />
      </div>
      <div className="group-input">
        <div className="d-flex align-items-center">
          <LabelField
            title={"Assign to"}
            style={{
              fontSize: "12px",
            }}
            mandatory={true}
          />
          <InfoTooltip text="The staff member/user this task will be assigned to when it's created." placement="bottom" useFixed style={{ marginLeft: '6px', marginBottom: '4px', transform: 'translateY(-3px)' }} />
        </div>
        <Select
          menuPosition={'fixed'}
          classNamePrefix="react-select"
          formatOptionLabel={formatOptionLabel}
          placeholder="Select a clergy"
          options={usersData || []}
          styles={selectStyles}
          onChange={(value) => {
            formik.setFieldValue("clergyType", value);
          }}
          value={formik.values?.clergyType}
          components={{ DropdownIndicator }}
        />
      </div>
      <div className="group-input">
        <InputField
          {...{
            formik,
            title: "Subject",
            name: "subject",
            checkValidation: true,
            value: formik.values?.subject,
            titleStyle: {
              fontSize: "12px",
            },
            mandatory: false,
          }}
        />
      </div>
      <TextMessage
        onTokenDoubleClicked={onTokenDoubleClicked}
        onTextAreaChange={onTextAreaChange}

        value={formik.values?.text}
      />
      <div className="contact-trigger">
        <div className="d-flex align-items-center">
          <LabelField
            title={"Who would you like to contact?"}
            style={{
              fontSize: "12px",
            }}
            mandatory={true}
          />
          <InfoTooltip text="Choose whether this task is about contacting the member themselves, or a specific relation of theirs (e.g. spouse, parent, child)." placement="bottom" useFixed style={{ marginLeft: '6px', marginBottom: '4px', transform: 'translateY(-3px)' }} />
        </div>
        <div className="right-trigger">
          <SwitchTabs
            options={isPersonalOptions}
            value={formik.values?.isPersonal}
            onChange={(tab) => formik.setFieldValue("isPersonal", tab?.value)}
          />
        </div>
      </div>
      {formik.values?.isPersonal === 0 && (
        <TriggerCommon
          options={contactTypes}
          onChange={(value) => {
            formik.setFieldValue("contactType", value);
          }}
          selectedValue={formik.values?.contactType}
        />
      )}

    </div>
  );
}

export default CreateTrigger;
